import { useGasv3Listener } from '@atlassian/post-office-context';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useEffect } from 'react';

export const useClickedRovoNudgeCta = ({ nudgeId }: { nudgeId: string }): void => {
	const { messageInstanceClicked } = useMessageInstanceEvent();

	const clicked = useGasv3Listener({
		action: 'clicked',
		actionSubject: 'rovoButton',
		actionSubjectId: 'aiRovoProactiveNudge',
		attributes: {
			recommendationFeatureId: nudgeId,
		},
	});

	useEffect(() => {
		if (clicked) {
			void messageInstanceClicked({
				messageEventType: 'clicked',
				clickedElement: {
					clickIdentifier: 'cta',
					clickedElement: 'button',
					buttonType: 'primary',
				},
				action: { actionType: 'open' },
				additionalMetadataFromFrontend: {},
			});
		}
	}, [clicked, messageInstanceClicked]);
};
